import { memo, useContext } from 'react';
import { MediaPlaybackBufferContext } from '../../context/MediaPlaybackBufferContext';
import { MediaPlayerBar } from './MediaPlayerBar';
import { jsx as _jsx } from "react/jsx-runtime";
export const __MediaBufferProgress = () => {
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const {
    percentLoaded
  } = useContext(MediaPlaybackBufferContext);
  return /*#__PURE__*/_jsx(MediaPlayerBar, {
    backgroundColor: "border-core-default",
    inlineSize: `${percentLoaded}%`
  });
};
export const MediaBufferProgress = /*#__PURE__*/memo(__MediaBufferProgress);